import React, { ReactNode, useMemo, useEffect } from "react";
import ReactDOM from "react-dom";

interface IModalPortal {
  children: ReactNode;
}

function modalPortal(props: IModalPortal) {
  const rootElement = useMemo(() => document.getElementById("modal-root"), ["modal-root"]);
  return rootElement ? ReactDOM.createPortal(props.children, rootElement) : null;
}

export default modalPortal;
